import Select from "../../../../form/Select";
import React from "react";
import isEqual from "lodash-es/isEqual";
import {optionsTemplate} from "../../../../../utils/formatters";

export class Target extends React.Component {

    componentDidUpdate(prevProps, prevState, prevContext) {
        const propsTop = {...this.props};
        const {props} = propsTop;
        const prevPropsTop = {...prevProps};
        const pProps = prevPropsTop.props;
        if (isEqual(props.values.id + "", (pProps || {}).id + "") && !isEqual((props.values.customer || {}).partner_id, (((pProps || {}).values.customer) || {}).partner_id)) {
            props.setFieldValue("target", null);
        }
    }

    render() {
        const propsTop = {...this.props};
        const {props, state, parent} = propsTop;
        const {hidden, labels} = props;
        return (hidden || []).indexOf("target") === -1 && <Select
            label={labels.target || "Hova"}
            name="target"
            component="location"
            objectValue={true}
            labelKey="name"
            storeType="local"
            autoSelect={true}
            optionsTemplate={optionsTemplate("location")}
            filter={[{
                field: "roles.optionid",
                value: "4" // ShopSupplyStore
            }]}
            {...props.getProps("target")}
            value={props.getValue("target")}
            saveChanges={props.setFieldValue}
        />;
    }
}

export default Target;